import { call } from 'redux-saga/effects';
import * as Api from '../../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../../helpers/saga';
import { fetchLowStockItems as fetchLowStockItemsRoutine } from './routines';

export const fetchLowStockItems = ({ payload: body }) =>
  sagaRoutineRequest(fetchLowStockItemsRoutine, {
    request: () => call(Api.fetchLowStockItems, body)
  });
